export default __webpack_public_path__ + "media/images/acres-icon-0c6a0585bd2b31329815e8ef1b1c24a2.svg";